import { window } from '../window.js';
import { HTMLControl } from './html_control.js';
import './popup_control.js';

/**
 * Date control.
 */
class DateControl extends HTMLControl {
  constructor() {
    super();

    this.errormsg = `
      Please enter estimated start date of the trip. Expected format is:
      <i><b>yyyy-mm-dd</b></i>, for example: '2016-07-29' stands for
      29th July 2016. The date is used to generate a checklist and to
      show weather.
    `;
  }

  initialize() {
    this.classList.add(
      'popup-container',
      'popup-arrow',
      'editable-control-container'
    );

    super.initialize();

    this.editableControlElement.onfocus = this.onFocus.bind(this);

    this.dateElement.onfocus = this.onInputFocus.bind(this);
    this.dateElement.onblur = this.onInputBlur.bind(this);

    this.popupElement.innerHTML = this.errormsg;
  }

  static markup = `
<span class='editable-control' tabindex='-1'>
  <span class='editable-control-label'></span>
  <span class='editable-control-value'></span>
  <input type='date'
         class='editable-control-date'
         size='10'
         placeholder='yyyy-mm-dd'
         tabindex='0'>
</span>
<popup-control></popup-control>
`;

  static properties = {
    label: {
      attribute: true,
      set(v) {
        this.labelElement.innerHTML = `${v}:&nbsp;`;
      },
    },
    plainStyle: {
      attribute: {
        name: 'plain',
        type: 'boolean',
      },
      set(v) {
        this.editableControlElement.setAttribute('tabindex', v ? 0 : -1);
      },
    },
    readonly: {
      attribute: 'boolean',
      set(v) {
        this.dateElement.readOnly = v;
      },
    },
    value: {
      attribute: true,
      get() {
        return this.dateElement.value;
      },
      set(v) {
        this.valueElement.textContent = v;
        this.dateElement.value = v;
      },
      preset(v) {
        if (v) {
          let r = /\d{4}-\d{2}-\d{2}/.exec(v);
          if (r) {
            v = r[0];
          }
        }
        return v;
      },
    },
  };

  onFocus() {
    this.editableControlElement.setAttribute('hasfocus', 'true');
    this.dateElement.focus();
  }

  onInputFocus() {
    this.editableControlElement.setAttribute('hasfocus', 'true');
  }

  onInputBlur() {
    this.editableControlElement.removeAttribute('hasfocus');
    this.hideBalloon();

    // Chrome fires 'change' event on every value change similar to 'input'
    // event. Call in timeout to put the focus back.
    setTimeout(() => {
      if (this.getAttribute('value') != this.value && this.validate()) {
        this.valueElement.textContent = this.dateElement.value;
        this.dispatchEvent(
          new CustomEvent('valuechange', {
            detail: this.value,
          })
        );
      }
    }, 0);
  }

  checkValidity() {
    return !isNaN(Date.parse(this.value));
  }
  showBalloon() {
    this.popupElement.open = true;
  }
  hideBalloon() {
    this.popupElement.open = false;
  }

  validate() {
    let el = this.editableControlElement;
    if (this.checkValidity()) {
      el.removeAttribute('invalid');
      this.hideBalloon();
      return true;
    }

    el.setAttribute('invalid', 'true');
    el.focus();
    this.showBalloon();
    return false;
  }

  static selectors = {
    EditableControl: '.editable-control',
    Date: '.editable-control-date',
    Label: '.editable-control-label',
    Popup: 'popup-control',
    Value: '.editable-control-value',
  };

  static elements = {
    editableControlElement: this.selectors.EditableControl,
    dateElement: this.selectors.Date,
    labelElement: this.selectors.Label,
    popupElement: this.selectors.Popup,
    valueElement: this.selectors.Value,
  };
}

window.customElements.define('date-control', DateControl);

export { DateControl };
